import React from 'react';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import HelpOutline from '@material-ui/icons/HelpOutline';
import PhoneOutlined from '@material-ui/icons/PhoneOutlined';
import NotificationsNone from '@material-ui/icons/NotificationsNone';
import IconButton from '@material-ui/core/IconButton';
import logo from '../../../img/logo/icon_cosmocare.svg';

import { changeDrawerState } from '../../../redux/actions/drawerActions'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0,
  },
  appBar: {
    background: 'rgba(255,255,255,0.95)',
    color: '#222',
    zIndex: theme.zIndex.drawer + 1,
  },
  iconButton: {
    width: 36,
    // height: 36,
    color: '#dddddd'
  },
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }
});


class AppBarLandingMobile extends React.PureComponent {

  state = {
    anchorEl: null,
  };


  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  toggleDrawer = () => {
    this.props.dispatch(changeDrawerState())
  }

  render() {
    const { classes, auth, hideLogo } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar>

            <Typography variant="title" color="inherit" className={classes.flex}>
              {!hideLogo && <img src={logo} style={{maxHeight: 28}} />}
            </Typography>

            <div>
            <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.toggleDrawer}>
              <MenuIcon />
            </IconButton>
            </div>
          
        </Toolbar>
      </AppBar>
    )
  }
}

export default connect(state => ({
  drawerState: state.drawer.open,
  auth: state.auth
}))(withStyles(styles)(AppBarLandingMobile));


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppBarLandingMobile.js